import { api } from "@/utility/axios";
import { BookModel } from "@/types";
import { apiConfig } from "@/configs/appConfig";
import { get, set } from "@/data/ionicStorage";
type List<T> = T[];
export const SmartBookService = {
  getBookById: async (bookId: number): Promise<BookModel> => {
    try {
      const response = await api.get<BookModel>(apiConfig.downloadBook, {
        params: {
          bookId: bookId,
          includePageItems: true,
          includePageImages: false,
          includeGfImages: false,
        },
      });
      return response.data;
    } catch (ex) {
      return Promise.reject(ex);
    }
  },

  getGroupBooks: async (bookId: number): Promise<List<BookModel>> => {
    try {
      const groupBooks: List<BookModel> = (await get(
        `group-book-${bookId}`
      )) as List<BookModel>;
      if (groupBooks) {
        return groupBooks;
      } else {
        const response = await api.get<List<BookModel>>(
          apiConfig.getGroupBooks,
          {
            params: {
              groupBookId: bookId,
              includeCoverImage: false,
            },
          }
        );
        if (response.data) {
          await set(`group-book-${bookId}`, response.data);
          return response.data;
        } else {
          return response.data;
        }
      }
    } catch (ex) {
      return Promise.reject(ex);
    }
  },
};
